import getLang from 'app/common/services/getLang';

export const buildHelpCenterUrl = (articleId?: number): string => {
    const path = articleId ? `articles/${articleId}` : '';
    return `https://help.partoo.co/${getLang()}/${path}`;
};
